import * as React from "react"
import { useLocalize } from "@/modules/shared/context/localize/LocalizeContext";
import { FieldCheckbox } from "../components/FieldCheckbox";
import { DateField } from "@/ui/form/controls/DateField";


type Props = {
    className?: string
    loading?: boolean
    translateKey?: string
    state: { configuration: { calculationStartDate: any, calculateAmountsForCountry: boolean } }
    setState: React.Dispatch<React.SetStateAction<{ configuration: { calculationStartDate: any, calculateAmountsForCountry: boolean } }>>
}

export const CalculationStartDateSection = ({
    className,
    loading,
    translateKey,
    state,
    setState,
}: Props) => {
    const { t } = useLocalize()

    const updateValue = React.useCallback((name: string, value: any) => {
        setState((s) => ({
            ...s,
            configuration: {
                ...s.configuration,
                [name]: value,
            },
        }))
    }, [setState])

    if (loading) {
        return <p>Loading...</p>
    }

    const basicConfiguration = state.configuration
    // basicConfiguration.calculateAmountsForCountry
    return (
        <div className={className}>
            <div className="tw-flex tw-gap-4 tw-items-center tw-content-justify  tw-px-4 tw-my-4 tw-w-100">
                <FieldCheckbox
                    checked={basicConfiguration.calculateAmountsForCountry}
                    onChange={(e) => updateValue('calculateAmountsForCountry', e.target.checked)}
                    label={t('configuration.minimumWages.calculateMinimalWagesFrom')}
                />
                <div className="tw-w-[180px]">
                    <DateField
                        value={basicConfiguration.calculationStartDate ?? null}
                        setValue={(v) => updateValue('calculationStartDate', v ?? '')}
                        disabled={!basicConfiguration.calculateAmountsForCountry}
                    />
                </div>
            </div>
        </div>
    )
}
